// Item 3 (Neo Iteration 134) — lightweight inline-SVG 7-day trend, no charting library needed.
export function ContactsSparkline({ data, testId }) {
  if (!data || data.length === 0) return null;
  const max = Math.max(1, ...data.map((d) => d.count));
  const width = 280;
  const height = 48;
  const padding = 4;
  const stepX = (width - padding * 2) / (data.length - 1);
  const pointFor = (d, i) => {
    const x = padding + i * stepX;
    const y = height - padding - (d.count / max) * (height - padding * 2);
    return { x, y };
  };
  const points = data.map((d, i) => { const p = pointFor(d, i); return `${p.x},${p.y}`; }).join(" ");

  return (
    <div data-testid={testId} className="text-igc-goldText">
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="w-full max-w-[280px]">
        <polyline points={points} fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        {data.map((d, i) => {
          const p = pointFor(d, i);
          return <circle key={d.date} cx={p.x} cy={p.y} r="2.5" fill="currentColor" />;
        })}
      </svg>
      <div className="flex justify-between text-[10px] text-igc-muted mt-1 max-w-[280px]">
        {data.map((d) => (
          <div key={d.date} className="flex flex-col items-center" data-testid={`${testId}-day-${d.date}`}>
            <span className="text-igc-cream font-medium">{d.count}</span>
            <span>{d.day_label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
